class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.pagination = this.querySelectorAll('.slider-pagination__dot');
    this.isAutoplay = this.slider.getAttribute('attr-slider-autoplay') || false;
    this.speed = this.slider.getAttribute('attr-slider-speed') * 1000;
    this.autoplayInit = false;

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this), {passive: true});
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();

    if (this.isAutoplay && !this.autoplayInit) {
      this.sliderItems[0].classList.add("slidein");
    }
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    this.pagination.forEach((dot, index) => {
      index + 1 == this.currentPage ? dot.classList.add('active') : dot.classList.remove('active')
    })
    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
    if (this.isAutoplay && !this.autoplayInit) {
      this.previousPage = 1;
      setInterval(() => this.autoplay(), this.speed);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  autoplay() {
    this.autoplayInit = true;

    const addSlideIn = () => {
      // incoming slide
      this.sliderItems[this.currentPage - 1].classList.add("slidein");
      this.sliderItems[this.currentPage - 1].classList.add("active");
    }

    this.sliderItems.forEach(function(slide) {
      slide.classList.remove("slideout");	
      // outgoing slide
      slide.classList.remove("slidein");
      slide.classList.remove("active");
    });
    // *** Add class from sliding out photo *** //
    this.sliderItems[this.currentPage - 1].classList.add("slideout");
    
    this.previousPage = this.currentPage;
    this.currentPage = this.currentPage + 1;

    if (this.currentPage > this.totalPages) {
      this.currentPage = 1;
      this.previousPage = this.totalPages;
      addSlideIn();
    } else {
      addSlideIn();
    }
  }
}

customElements.define('slider-component', SliderComponent);
